var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-page',{attrs:{"title":_vm.title}},[_c('template',{slot:"actions"},[_c('va-list-button',{attrs:{"resource":_vm.resource}}),_vm._t("actions"),_c('va-locale-button',{attrs:{"resource":_vm.resource}})],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }